export const APIConstants = {
  admin: "user-admin",
  role: "role",
  addMember: "member",
  getMerchant: "get-merchant",
  getFraudDetection: "get-fraud-detect-details",
  saveFraudDetection: "add-fraud-detect-details",
  getReceipts: "get-member-receipts",
  receiptApi: "receipt",
  v2Receipts: "v2/receipt",
  pendingReceipts: "/v1/soundbox/receipt",
  approvePendingReceipts: "/v1/soundbox/receipt/approve",
  rejectPendingReceipts: "/v1/soundbox/receipt/reject",

  merchant: "merchant",
  getEVouchers: "v2/rewards/user",
  LoyaltyPoints: "manual-points",
  login: "sign-in",
  forgotPassword: "forgot-password",
  getCustomer: "customer",
  customer: "admin/customer",
  carParkLogs: "car-park-dollar/getlogs",
  verifyOTP: "verify-otp",
  resetPassword: "reset-password",
  eVouchers: "evouchers",
  getMemberLogs: "getLogs",
  carParkBalance: "car-park-dollar",
  sendEmail: "export-receipts",
  export: "export",
  qrValidate: "qr/customer/validate",
  qrGenerate: "qr/customer",
  addShopUser: "shop-user",
  randomAudit: "random-audit",
  getMerchantDeals: "v1/home",
  getAllSales: "get-all-orders",
  getSalesListingDetails: "v2/get-vouchers",
  getFlashSales: "flashsales",
  getReportById: "v2/get-report-id",
  getMerchantReport: "get-merchant-reports",
  saleEvoucher: "sale/evoucher",
  salesReport: "reports",
  memberRedemption2: "v2/cs-redemption/redeem?receiptIds=",
  memberRedemption:
    "v2/cs-redemption?partners=true&max_receipts=true&eligible_offers=true&receiptIds=",
  partnerSelection: "member-redemptions-partner",
  getRedemptionOffers:
    "v2/cs-redemption/values?partners=true&max_receipts=true",
  getVoucherTransaction: "get-merchant-vouchers",
  refreshToken: "refresh-token",
  physicalVoucher: "v2/submitted-voucher",
  getPhysicalVoucherList: "voucher",
  proceedReimbursement: "v2/submitted-voucher",
  getAllReimbursementEvoucher: "v3/get-utilized-list",
  getReimbursementEvoucher: "v2/submitted-voucher",
  getReimbursementPVoucherCount: "submitted-voucher-all",
  getReimbursementEvoucherCount: "submitted-voucher-all",
  addPhysicalVoucher: "physical-voucher-add",
  addPhysicalVoucherBulk: "physical-voucher-add-csv",
  getAllPhysicalVoucher: "v2/physical-vouchers",
  getCorporateLog: "getCorporateLogs",
  deleteVoucher: "remove-vouchers-from-report",
  addVoucherIntoReport: "add-voucher-into-report",
  physicalVoucherRemove: "physical-voucher-remove",
  getVoucherTransactionForMerchant: "v2/get-utilized-list",
  getDashboardDetails: "get-dashboard-details",
  physicalVoucherStatus:
    "import-physical-voucher-status?key=invalid-vouchers/invalid_",
  offers: "offers",
  permissions: "permissions",
  getMasterPermissions: "master-permissions?role=",
  getRolePermission: "permissions?role=",
  updateRolePermissions: "v2/role",
  fraudDetect: "receipt-fraud-checks",
  finance_reports: "finance-reports",
  update_email: "update-email",
  bulkUpload: "bulkUpload",
  download: "download",
  hubspotDecryptText: "hubspot/decrypt-text",
  // getMembers: "get-memberList",
  // getMember: "get-member",
  // uploadReceipt: "upload-member-receipt",
  // getRewards: "vouchers/user",
  // logout: "logout",
  // getDeals: "rewards",
  // getVouchersByMerchant: "v2/get-utilized-list",
  // getRewardVouchers: "get-reward-vouchers",
  // listShopUser: "shop-user-list",
  // merchantNewAPI: "v1/home",
  // cutOffReport: "/get-cutoff-report",
  // fetchFromS3: "suntec-physical-voucher-imports-dev?key=",
};

export const APIModuleConstants = {
  pvoucher: "reimbursementReport",
  merchantPvoucher: "merchantpvoucher",
  merchantEvoucher: "merchantEvoucher",
  pvoucherReport: "pvVoucherDetail",
  evoucherReport: "EvoucherReport",
  corporateLogs: "corporateLogs",
  adminUser: "adminUser",
  salesListing: "salesListing",
  memberPoints: "loyaltypoints",
  memberCarparkLogs: "carpark",
  voucherTransactions: "Evouchers",
  salesListingDetails: "OrderId",
  receipt: "Receipts",
};

export const APILimit = "?limit=50";

export const URLConstants = {
  UATadmiURL: "suntec-uat-bi.capillarytech.com",
  UATMerchantURL: "suntec-uat-merchant.capillarytech.com",
  UATCSadminURL: "suntec-uat-cs.capillarytech.com",
  adminURL: "suntec-bi.capillarytech.com",
  merchantURL: "suntec-merchant.capillarytech.com",
  csAdminURL: "suntec-cs.capillarytech.com",
};
